import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import aboutUs from '@/pages/concerning/aboutUs'
import occupationalHygiene from '@/pages/serviceItems/occupationalHygiene'
import safetyAssessment from '@/pages/serviceItems/safetyAssessment'
import environmentDetection from '@/pages/serviceItems/environmentDetection'
import reports from '@/pages/reports/reports'
import newsList from '@/pages/reports/newsList'
import publicNotice from '@/pages/reports/publicNotice'
import newsInfo from '@/pages/reports/newsInfo'
import contactUs from '@/pages/concerning/contactUs'
import reportInfo from '@/pages/reports/reportInfo'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: index
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/occupationalHygiene',
      name: 'occupationalHygiene',
      component: occupationalHygiene
    },
    {
      path: '/safetyAssessment',
      name: 'safetyAssessment',
      component: safetyAssessment
    },
    {
      path: '/environmentDetection',
      name: 'environmentDetection',
      component: environmentDetection
    },
    {
      path: '/reports',
      name: 'reports',
      component: reports
    },
    {
      path: '/reportInfo',
      name: 'reportInfo',
      component: reportInfo
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: newsList
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: newsList
    },
    {
      path: '/publicNotice',
      name: 'publicNotice',
      component: publicNotice
    },
    {
      path: '/newsInfo',
      name: 'newsInfo',
      component: newsInfo
    },
    {
      path:'/contactUs',
      name: 'contactUs',
      component: contactUs
    }
  ],
  // mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js